module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {}, [_c('div', {
    staticClass: "flex items-end"
  }, [_c('span', {
    staticClass: "f2 b title-responsive ml4-ns"
  }, [_vm._v(_vm._s(_vm.$t('menu.accountsettings', {
    accountsettings: 'Account Settings'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mv4-l mv2"
  }, _vm._l((this.$store.state.messages), function(message, index) {
    return _c('ak-alert', {
      key: index,
      attrs: {
        "color": message.color,
        "deleteable": message.deleteable
      },
      on: {
        "close": function($event) {
          return _vm.clearMessage(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(message.text))])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap justify-evenly content"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m pointer"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/account/personal"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/PersonalInformation.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v(_vm._s(_vm.$t('menu.personalinformation', {
    personalinformation: 'Personal Information'
  })))]), _vm._v(" "), _c('span', {
    staticClass: "font-size-text inter"
  }, [_vm._v(_vm._s(_vm.$t('menu.personalinformationdescription', {
    personalinformationdescription: 'View and modify your personal information'
  })))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m mb0 pointer"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/account/security"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/Security.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v(_vm._s(_vm.$t('menu.loginsecurity', {
    loginsecurity: 'Login & Security'
  })))]), _vm._v(" "), _c('span', {
    staticClass: "font-size-text inter"
  }, [_vm._v(_vm._s(_vm.$t('menu.loginsecuritydescription', {
    loginsecuritydescription: 'View & manage your security details'
  })))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m mb0 pointer"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/account/plans"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/Plans.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v(_vm._s(_vm.$t('menu.plans', {
    plans: 'Plans'
  })))]), _vm._v(" "), _c('span', {
    staticClass: "font-size-text inter"
  }, [_vm._v(_vm._s(_vm.$t('menu.plansdescription', {
    plansdescription: 'View, change and add plans to your account'
  })))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m pointer"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/account/billing"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/BillingInformation.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v(_vm._s(_vm.$t('menu.billing', {
    billing: 'Billing'
  })))]), _vm._v(" "), _c('span', {
    staticClass: "font-size-text inter"
  }, [_vm._v(_vm._s(_vm.$t('menu.billingdescription', {
    billingdescription: 'View and update billing details'
  })))])])])])], 1), _vm._v(" "), (_vm.uiSettings[_vm.showReferrals] !== false) ? _c('div', {
    staticClass: "w-30-l pa4 bg-white account-card mb4-l mb4-m mb0 pointer"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/account/referrals"
    }
  }, [_c('div', {
    staticClass: "responsive-card"
  }, [_c('img', {
    staticClass: "mr1 mb1",
    attrs: {
      "alt": "",
      "src": require("../../../static/appicons/Referrals.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-center text-responsive"
  }, [_c('h4', {
    staticClass: "mb2 cera-round-pro-medium fw1"
  }, [_vm._v(_vm._s(_vm.$t('menu.referrals', {
    referrals: 'Referrals'
  })))]), _vm._v(" "), _c('span', {
    staticClass: "font-size-text inter"
  }, [_vm._v(_vm._s(_vm.$t('menu.referralsdescription', {
    referralsdescription: 'Earn deductible credits by sharing AKKO'
  })))])])])])], 1) : _c('div', {
    staticClass: "w-30-l empty-card pa4 bg-white mb4-l mb4-m mb0 o1"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-30-l empty-card pa4 bg-white mb4-l mb4-m mb0 o1"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e44c1b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/UnifiedAccountSettings.vue
// module id = 1252
// module chunks = 0